import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedName from 'I18n/components/FormattedName';
import { jsx as _jsx } from "react/jsx-runtime";
const TEMPLATES_URI = 'salescontentsearch/v2/search';
// eslint-disable-next-line no-restricted-syntax
let cache;

/**
 * Meant to be used in Unit / Integration tests only
 */
export const bustTemplatesApiCache = () => {
  cache = null;
};
const createTemplateOptions = templatesResponse => {
  return templatesResponse.results.map(template => ({
    text: template.name,
    value: template.contentId,
    help: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "hubspot-prosemirror.templates.help",
      options: {
        name: /*#__PURE__*/_jsx(FormattedName, {
          givenName: template.userView.firstName,
          familyName: template.userView.lastName,
          email: template.userView.email
        })
      }
    }),
    id: template.contentId
  }));
};
const getPostBody = ({
  limit = 1000,
  offset = 0,
  query = '',
  sorts = []
} = {}) => ({
  query,
  limit,
  offset,
  sorts,
  filters: [{
    field: 'content_type',
    values: ['TEMPLATE']
  }],
  contentTypesToHydrate: ['TEMPLATE']
});
export function fetchTemplates(httpClient, searchTerm) {
  let promise;
  if (cache && !searchTerm) {
    promise = Promise.resolve(cache);
    promise.catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return promise;
  }
  promise = httpClient.post(TEMPLATES_URI, {
    data: getPostBody({
      query: searchTerm || '',
      limit: searchTerm ? 100 : 1000,
      offset: 0,
      sorts: searchTerm ? [] : [{
        field: 'updated_at',
        order: 'DESC'
      }]
    })
  }).then(res => {
    const templateOptions = createTemplateOptions(res);
    if (!searchTerm) {
      cache = templateOptions;
    }
    return templateOptions;
  }).catch(error => {
    return Promise.reject(error);
  });
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
}
const fetchTemplate = (templateId, httpClient, email, supplementalObjects) => {
  const uri = `/sales-templates/v2/templates/render`;
  // TSFixMe: add dependency on sales-templates-service-types-lib
  return httpClient.post(uri, {
    data: {
      templateId,
      contactEmail: email,
      supplementalObjects,
      missingTokenTransformer: 'NONE'
    }
  });
};
export const templatesApiWrapper = apiClient => ({
  fetchRenderedContent({
    id,
    contactEmail,
    supplementalObjects
  }) {
    return fetchTemplate(id, apiClient, contactEmail, supplementalObjects).then(res => ({
      htmlBody: res.html,
      metadata: {
        templateId: id,
        subject: res.subject
      }
    }));
  },
  searchTemplates({
    query
  }) {
    return fetchTemplates(apiClient, query);
  }
});